import {
  MutateVariantResponse,
  SelectVariantMode,
  VariantConfigurationContextState,
} from 'modules/experiments/types';
import { createContext, useContext } from 'react';
import noop from 'utils/noop';
import { z } from 'zod';
import { MutatedExperimentVariant } from '../takeover/types';

export const initialVariantConfigurationContextState: VariantConfigurationContextState = {
  isEditSelectMode: false,
  isPreviewSelectMode: false,
  hasMaximumNumberOfVariants: false,
  selectedVariant: null,
  selectedVariantErrorCount: 0,
  variantIssueCount: 0,
  variantIssues: [],
  selectMode: SelectVariantMode.PREVIEW,
  formFieldSchema: [],
  formFieldZodSchema: z.object({}),
  variantList: [],
  addingNewVariant: false,
  deletingActiveVariant: false,
  setDeletingActiveVariant: noop,
  addNewVariant: () => new Promise((resolves) => resolves()),
  deleteExperimentVariant: () => new Promise((resolves) => resolves(true)),
  renameExperimentVariant: () => new Promise((resolves) => resolves(true)),
  getPrecedingVariant: () => ({}) as MutatedExperimentVariant,
  setEditSelectMode: noop,
  setPreviewSelectMode: noop,
  toggleToPreviewSelectMode: noop,
  updateSelectedVariantContent: noop,
  updateExperimentVariant: () => new Promise((resolves) => resolves({} as MutateVariantResponse)),
};

export const VariantConfigurationContext = createContext(initialVariantConfigurationContextState);

export const useVariantConfigurationContext = () => useContext(VariantConfigurationContext);
